// extracted by mini-css-extract-plugin
export default {"root":"PriceHandler_root__Fz68t"};